function SuggestedDesigns(
  parentSelector,
  apiEndPoint,
  articleID,
  blogID,
  additionalHandler
) {

  function toQueryParams(articleID, blogID) {
    return '?articleID=' + articleID + '&blogID=' + blogID;
  }

  this.load = function() {
    var request = $.ajax({
      type: 'GET',
      url:
        'https://apps.joltteam.com/' + apiEndPoint.replace(/^\//, '') +
          toQueryParams(articleID, blogID),
    });

    request.done(function(response) {
      $('.suggested-designs-loader', parentSelector).hide();
      if (response.designs.length === 0) {
        $(parentSelector).hide();
        return;
      }

      $('.suggested-designs-list', parentSelector).append(
        $.map(response.designs, function(design) {
          return $('<div class="col-md-2 suggested-designs-list-item"></div>')
            .append($('<a class="suggested-design"></a>')
              .attr(
                'href',
                '/blogs/' + design.blogHandle + '/' + design.handle
              )
              .append(
                $('<img class="article-image">').attr(
                  'src',
                  design.articleImage
                )
              )
            )
          }
        )
      );

      $('.suggested-designs-list', parentSelector).show();
      $('.suggested-designs-header', parentSelector).show();
      if (additionalHandler) {
        additionalHandler(response);
      }
    });

    request.fail(function(jqXHR, textStatus) {
      $(parentSelector).hide();
      console.log('Error from server, httpStatus:', jqXHR.status,
        ' message:', jqXHR.responseText, ';', textStatus);
    });
  }
}
